import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgOilCleanserGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.295 32.4c.787.6 1.672.9 2.754.9s2.066-.3 2.755-.9c2.065-1.6 2.36-4.3.786-6.5-.491-.7-.885-1.2-1.278-1.7l-.12-.147c-.92-1.12-1.552-1.89-1.552-2.753h-1.18c0 1-.69 1.9-1.771 3.2-.295.4-.689.9-1.082 1.4-1.672 2.1-1.279 4.8.688 6.5Zm1.279-7.1c.59-.7 1.082-1.4 1.475-2 .239.363.477.69.737 1.047.17.232.348.477.542.753.137.174.286.348.439.527.285.334.583.682.84 1.073 1.18 1.7.885 3.6-.59 4.8-.984.9-2.853.8-3.935 0-1.574-1.3-1.77-3.2-.59-4.8.393-.5.787-1 1.082-1.4Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.705 18.2c-.098-.8-.59-1.5-1.377-1.9l-3.738-2v-3.5s.099 0 .099-.1c1.082-.7 1.18-1.3 1.082-1.7-.099-.4-.492-.9-1.77-1-.788 0-1.673.1-2.657.3-1.672.5-3.442 1.4-3.54 2.5v3.3l-4.132 2.2c-.688.4-1.278 1.1-1.377 1.9-.492 3.5-.59 15 2.164 20.6l.099.1c.688.8 3.934 1.1 6.688 1.1.738 0 1.442-.033 2.039-.061.438-.021.817-.039 1.109-.039 2.36-.2 2.852-.7 3.147-1.1 2.754-5.6 2.656-17.2 2.164-20.6Zm-10.328-7.7c.394-.3 1.18-.7 2.263-1 1.475-.4 2.459-.3 2.852-.2-.098.1-.393.3-.689.5-.116.047-.237.1-.366.156-.415.18-.901.391-1.503.544-1.475.4-2.459.4-2.852.3l.295-.3Zm-.393 1.5c.098 0 .172.025.246.05.07.024.142.048.235.05h.386a10.224 10.224 0 0 0 2.28-.3c.196-.05.392-.1.587-.162l.102-.038c.104-.04.209-.08.313-.116.06-.026.12-.054.179-.084v.027c.032-.01.065-.019.098-.027V14h-4.525v-2c.033.017.066.03.099.042V12Zm7.475 26.2c-.885.8-9.836.8-10.918 0-2.557-5.2-2.557-16.2-2.066-19.8.099-.4.296-.8.689-1l4.131-2.2h5.312l4.13 2.2c.394.2.591.6.69 1 .59 3.6.59 14.8-1.968 19.8Z",
    fill: "currentColor"
  }));
}

export { SvgOilCleanserGlyph as default };
